import { FC, SVGProps } from 'react'

export const Guild: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    viewBox="0 0 1000 1000"
    fill="currentColor"
    {...props}
  >
    <g>
      <path
        d="M12.29,498.55c22.94,0,45.88,0,69.53,0c0,46.73,0,92.84,0,139.37c23.55,0,46.4,0,69.74,0c0-23,0-45.7,0-69.19
		c23.33,0,46.18,0,69.85,0c0-23.61,0-46.46,0-70.02c23.46,0,46.11,0,69.65,0c0-23.54,0-46.38,0-70.23c23.71,0,46.55,0,69.96,0
		c0-70.42,0-139.81,0-209.92c23.22,0,45.86,0,69.4,0c0-23.54,0-46.38,0-69.78c46.75,0,92.61,0,139.37,0c0,22.79,0,45.64,0,69.23
		c23.53,0,46.18,0,69.7,0c0,70.28,0,139.82,0,210.17c23.53,0,46.19,0,69.75,0c0,23.64,0,46.5,0,70.08c23.53,0,46.18,0,69.69,0
		c0,23.57,0,46.42,0,69.89c23.52,0,46.18,0,69.76,0c0,23.45,0,46.28,0,69.65c23.74,0,46.56,0,70.25,0c0-46.27,0-92.36,0-138.89
		c23.28,0,45.72,0,68.78,0c0,162.88,0,325.81,0,489.23c-115.57,0-231.14,0-347.52,0c0-116.58,0-232.84,0-349.84
		c-23.46,0-46.12,0-69.63,0c0-23.57,0-46.43,0-69.72c-46.95,0-93.05,0-139.98,0c0,22.94,0,45.79,0,69.35c-23.46,0-46.11,0-69.5,0
		c0,116.99,0,233.26,0,350.7c-3.64,0-6.54,0-9.45,0c-110.13,0-220.25,0-330.38,0.03c-2.99,0-5.98,0.38-8.97,0.59
		C12.29,825.68,12.29,662.11,12.29,498.55z M221.18,813.45c0-23.6,0-46.46,0-69.53c-23.28,0-46.11,0-69.07,0
		c0,23.44,0,46.46,0,69.53C175.34,813.45,198.02,813.45,221.18,813.45z M779.6,743.93c0,23.64,0,46.46,0,69.36
		c23.37,0,46.22,0,69.32,0c0-23.27,0-46.1,0-69.36C825.69,743.93,802.86,743.93,779.6,743.93z"
      />
      <path
        d="M569.9,7.85c-0.07,23.24-0.14,46.48-0.22,69.72c0,0,0.19-0.19,0.19-0.19c-45.72,0.07-91.44,0.14-137.16,0.17
		c-0.89,0-1.79-0.4-2.68-0.62l0.14,0.18c0.11-23.09,0.22-46.18,0.33-69.27C476.97,7.85,523.43,7.85,569.9,7.85z"
      />
      <path
        d="M430.03,76.94c0,23.17,0,46.33,0,70.13c-22.75,0-45.5,0-68.62,0c0-22.94,0-45.57,0-69.12c5.77,0,11.26,0.06,16.76-0.01
		c17.34-0.23,34.69-0.52,52.02-0.8C430.17,77.12,430.03,76.94,430.03,76.94z"
      />
      <path
        d="M569.68,77.57c22.94,0,45.88,0,69.4,0c0,23.65,0,46.44,0,69.68c-22.79,0-45.39,0-69.21,0c0-23.58,0-46.72,0-69.87
		C569.88,77.38,569.68,77.57,569.68,77.57z"
      />
    </g>
  </svg>
)
